import { PHONE_REGEX } from './query-highlight-utilities';

export const getQueryOptions = (hasInteractions) => {
  const queryOptions = {
    all: {
      icon: 'search',
      placeholder: 'Search all or select a category...',
      name: 'All',
      value: 'all',
    },
    name: {
      icon: 'person',
      placeholder: 'Search by name...',
      name: 'Name',
      value: 'name',
    },
    phone: {
      icon: 'call',
      placeholder: 'Search by phone...',
      name: 'Phone',
      value: 'phone',
    },
    email: {
      icon: 'email',
      placeholder: 'Search by email...',
      name: 'Email',
      value: 'email',
    },
    interaction: {
      icon: 'interactions',
      placeholder: 'Search interactions...',
      name: 'Interactions',
      value: 'interaction',
    },
    remoteId: {
      icon: 'industry',
      placeholder: 'Search by remote ID...',
      name: 'Remote ID',
      value: 'remoteId',
    },
  };

  if (!hasInteractions) {
    delete queryOptions.interaction;
  }

  return queryOptions;
};

export const getQueryTemplate = (query, type) => {
  const queryHasLetters = /[a-zA-Z]/.test(query);
  const queryHasNumbers = /[0-9]/.test(query);
  const cleanedPhoneQuery = queryHasLetters ? '' : query.replace(PHONE_REGEX, '');
  // const cleanedRemoteIdQuery = query.replace(REMOTE_ID_REGEX, ''); //not needed now, but possible for future use
  const queryParts = query.split(' ');
  const mustClauses = [];

  switch (type) {
    case 'phone':
      return {
        must: [
          {
            'phones.phone': { wildcard: `*${cleanedPhoneQuery}*` },
          },
        ],
      };
    case 'name':
      queryParts.map((part) => {
        mustClauses.push({
          name_first: { wildcard: `${part}*` },
          name_last: { wildcard: `${part}*` },
          name_middle: { wildcard: `${part}*` },
          name_nick: { wildcard: `${part}*` },
          name_maiden: { wildcard: `${part}*` },
          name_suffix: { wildcard: `${part}*` },
          name_prefix: { wildcard: `${part}*` },
        });
      });
      return {
        must: mustClauses,
      };
    case 'email':
      return {
        must: [
          { 'identities.type': { in: ['0'] } },
          {
            'emails.email': { wildcard: `${query}*` },
            'identities.value': { in: [query], wildcard: `*${query}*` },
            'identities.value.untouched': { in: [query], wildcard: `*${query}*` },
          },
        ],
      };
    case 'remoteId':
      return {
        must: [
          { 'identities.type': { in: ['1'] } },
          {
            'identities.value': { in: [query], wildcard: `*${query}*` },
            'identities.value.untouched': { in: [query], wildcard: `*${query}*` },
          },
        ],
      };
    case 'interaction':
      return {
        must: [
          {
            text: { in: [query], wildcard: `*${query}*` },
            summary: { in: [query], wildcard: `*${query}*` },
          },
        ],
        sort: [
          {
            date_occurred: {
              order: 'desc',
            },
          },
        ],
      };
    case 'all':
      if (queryParts.length > 1) {
        queryParts.map((part) => {
          mustClauses.push({
            name_first: { wildcard: `${part}*` },
            name_last: { wildcard: `${part}*` },
            name_middle: { wildcard: `${part}*` },
            name_nick: { wildcard: `${part}*` },
            name_maiden: { wildcard: `${part}*` },
            name_suffix: { wildcard: `${part}*` },
            name_prefix: { wildcard: `${part}*` },
          });
        });
        return {
          must: mustClauses,
        };
      } else {
        const allMustClause = {
          'identities.value': { in: [query], wildcard: `*${query}*` },
          'identities.value.untouched': { in: [query], wildcard: `*${query}*` },
          'emails.email': { wildcard: `${query}*` },
        };
        if (!queryHasNumbers) {
          allMustClause.name_first = { wildcard: `${query}*` };
          allMustClause.name_last = { wildcard: `${query}*` };
          allMustClause.name_middle = { wildcard: `${query}*` };
          allMustClause.name_nick = { wildcard: `${query}*` };
          allMustClause.name_maiden = { wildcard: `${query}*` };
          allMustClause.name_suffix = { wildcard: `${query}*` };
          allMustClause.name_prefix = { wildcard: `${query}*` };
        }
        if (cleanedPhoneQuery.length > 0) {
          allMustClause['phones.phone'] = { wildcard: `*${cleanedPhoneQuery}*` };
        }
        return {
          must: [allMustClause],
        };
      }
  }
};
